export const PORTER_CALLBACK_QUERY_PARAMS = {
  PID: "p_cb_pid",
  VERSION: "p_cb_v",
} as const;
